import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { rejectRequest } from "../../services/user/api";
import "../../styles/user/requestActionModal.css";

const DenyRequestPage = ({
  request,
  isOpen,
  onClose,
  onDenied,
  processing,
  setProcessing,
  formatRequestType,
}) => {
  const [rejectionReason, setRejectionReason] =
    useState("");

  const [
    rejectionReasonError,
    setRejectionReasonError,
  ] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setRejectionReason("");
      setRejectionReasonError("");
    }
  }, [isOpen]);

  if (!isOpen || !request) {
    return null;
  }


  const closeModal = () => {
    if (processing) {
      return;
    }

    setRejectionReason("");
    setRejectionReasonError("");
    onClose();
  };

  const handleDeny = async () => {
    const reason = rejectionReason.trim();

     const userId = Number(
    request?.userId ??
    request?.notificationId,
  );

  const requestId = Number(
    request?.requestId ??
    request?.redirectUrl,
  );

  if (
    !Number.isFinite(userId) ||
    !Number.isFinite(requestId)
  ) {
    toast.error(
      "Notification ID or Request ID is missing.",
    );
    return;
  }

    if (!reason) {
      setRejectionReasonError(
        "Rejection reason is required.",
      );
      return;
    }

    if (reason.length < 5) {
      setRejectionReasonError(
        "Rejection reason must contain at least 5 characters.",
      );
      return;
    }

    const updateRequest = {
     userId,
    requestId,
    rejectionReason : reason,
  };

    try {
      setProcessing(true);
      setRejectionReasonError("");

      const response = await rejectRequest(updateRequest);

      toast.success(
        response?.data?.message ||
          "Request denied successfully.",
      );

      onDenied(request);
      closeModal();
    } catch (error) {
      console.error(
        "Deny request error:",
        error?.response?.data || error,
      );

      toast.error(
        error?.response?.data?.message ||
          "Failed to deny request.",
      );
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="request-action-modal">
        <h3 className="deny-modal-title">
          Deny Request
        </h3>

        <p>
          Are you sure you want to deny the{" "}
          <strong>
            {formatRequestType(
              request?.requestType ?? request?.title,
            )}
          </strong>{" "}
          request?
        </p>

        <label
          htmlFor="rejectionReason"
          className="rejection-reason-label"
        >
          Rejection Reason
          <span className="required"> *</span>
        </label>

        <textarea
          id="rejectionReason"
          rows={4}
          maxLength={500}
          value={rejectionReason}
          className={`rejection-reason-textarea ${
            rejectionReasonError ? "input-error" : ""
          }`}
          placeholder="Enter rejection reason"
          onChange={(event) => {
            const value = event.target.value;
            setRejectionReason(value);

            if (value.trim().length >= 5) {
              setRejectionReasonError("");
            }
          }}
        />

        <div className="rejection-reason-footer">
          <span className="field-error">
            {rejectionReasonError}
          </span>

          <span>{rejectionReason.length}/500</span>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="modal-btn cancel"
            disabled={processing}
            onClick={closeModal}
          >
            Cancel
          </button>

          <button
            type="button"
            className="modal-btn reject-confirm"
            disabled={processing}
            onClick={handleDeny}
          >
            {processing ? "Denying..." : "Deny"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DenyRequestPage;